module.exports = __webpack_public_path__ + "static/tab03-9ebf9edeb95e78527c5d802a7aaa6597.png";